export const apiField = 's5_clamp';

const makeOptions = data => data.map(item => typeof item === 'object' ? item : ({ value: item, name: item }));


function makeConfig(data) {
  return{
    label: 'clamp',
    type: 'Select',
    apiField,
    missing: undefined,
    tooltip: undefined,
    data: makeOptions(data)
}};



export default function s5Clamp(filteredClampValues){
      return makeConfig(filteredClampValues);
    }